import { cloneElement, type JSX, type JSXElementConstructor, type ReactElement, useCallback } from 'react';
import { Provider, Tooltip, TooltipArrow, TooltipReference } from 'reakit';

import { useOddsGridContext } from '../../context/OddsGridContext';
import { closeGridToolTipCookie, closeGridToolTipLocalStorage } from '../../helpers';
import { type Placement, useAlwaysVisibleTooltip } from '../../hooks/useAlwaysVisibleTooltip';
import { useSelector } from '../../providers/StoreProvider';
import { gridExpanderTipArrow, gridExpanderTipStyles } from '../shared-styles';

import {
  SeeMoreOddsNoticeBody,
  SeeMoreOddsNoticeButton,
  SeeMoreOddsNoticeHeader,
  SeeMoreOddsNoticeWrapper,
} from './style';

export function SeeMoreOddsTip({
  children,
  givenPlacement,
  isVisible,
}: {
  children: ReactElement<unknown, string | JSXElementConstructor<any>>;
  givenPlacement: Placement;
  isVisible: boolean;
}): JSX.Element {
  const setSeeMoreOddsTooltip = useSelector(state => state.setSeeMoreOddsTooltip);

  const tooltip = useAlwaysVisibleTooltip(
    {
      id: 'gridExpanderTooltip',
      placement: givenPlacement,
      visible: isVisible,
    },
    isVisible,
  );
  const { isTabletOrDesktop } = useOddsGridContext();

  const closeToolTip = useCallback(() => {
    if (isTabletOrDesktop) {
      closeGridToolTipLocalStorage();
    } else {
      closeGridToolTipCookie();
    }
    setSeeMoreOddsTooltip(false);
  }, [isTabletOrDesktop, setSeeMoreOddsTooltip]);

  return (
    <Provider>
      {/**
				eslint-disable-next-line @typescript-eslint/ban-ts-comment
			 * @ts-expect-error */}
      <TooltipReference {...tooltip}>{referenceProps => cloneElement(children, referenceProps)}</TooltipReference>
      <Tooltip {...tooltip} className={gridExpanderTipStyles} style={{ pointerEvents: 'visible' }}>
        <TooltipArrow className={gridExpanderTipArrow} {...tooltip} />
        <SeeMoreOddsNoticeWrapper>
          <SeeMoreOddsNoticeHeader>Compare odds between 25+ bookmakers</SeeMoreOddsNoticeHeader>
          <SeeMoreOddsNoticeBody>
            These are the current best odds. Click the odds to compare between 25+ bookmakers and exchanges.
          </SeeMoreOddsNoticeBody>
          <SeeMoreOddsNoticeButton onClick={() => closeToolTip()} style={{ pointerEvents: 'visible' }}>
            Got it
          </SeeMoreOddsNoticeButton>
        </SeeMoreOddsNoticeWrapper>
      </Tooltip>
    </Provider>
  );
}
